import { FormikErrors, FormikValues } from 'formik';
import React from 'react';

import { ScoreResponse } from '@/api/api-client';
import { UITable } from '@/shared/components';

import { scoreColumns } from './duck';

interface ActivityTableProps {
  data: ScoreResponse[];
  loading: boolean;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<FormikValues>>,
}

const ActivityTable: React.FC<ActivityTableProps> = ({
  data,
  loading,
  setFieldValue,
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <UITable
      data={data}
      columns={scoreColumns}
      loading={loading}
      onRowClick={(item) => {
        void setFieldValue('activityId', item.std_id);
        void setFieldValue('score', item.score);
      }}
      pagination={{
        count: data.length,
        totalPages: data.length,
        rowsPerPage: rowsPerPage,
        page: page,
        onPageChange: (e, newPage) => handleChangePage(e, newPage),
        onRowsPerPageChange: (e) => handleChangeRowsPerPage(e),
      }}
    />
  );
};

export default ActivityTable;